<template>
    <div>
      <h2>Admissions Funnel Report</h2>
      <table border="1" cellspacing="0" cellpadding="5">
        <thead>
          <tr>
            <th>Staff Assigned</th>
            <th>Inquiries</th>
            <th>Applications</th>
            <th>Complete</th>
            <th>Admit</th>
            <th>Deposit</th>
            <th>Enroll</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in funnel" :key="index">
            <td>{{ row.staffAssigned }}</td>
            <td>{{ row.inqs }}</td>
            <td>{{ row.apps }}</td>
            <td>{{ row.complete }}</td>
            <td>{{ row.admit }}</td>
            <td>{{ row.deposit }}</td>
            <td>{{ row.enroll }}</td>
          </tr>
        </tbody>
      </table>
      <!-- Optional: A button to re-generate the funnel data -->
      <button @click="refreshFunnelData">Regenerate Report</button>
    </div>
  </template>
  
  <script>
  export default {
    name: 'FunnelReport',
    data() {
      return {
        // "funnel" will hold the array of funnel data for each staff member.
        funnel: this.generateFunnelData()
      };
    },
    methods: {
      // Helper function to generate a random integer between min and max (inclusive)
      randomInt(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      // Generate the funnel data array using the same logic as your Google Sheet.
      generateFunnelData() {
        // Define staff and their inquiry range
        const staffData = [
          { name: 'Boba Fett', inqsRange: [2400, 2500] },
          { name: 'Ellen Ripley', inqsRange: [2400, 2500] },
          { name: 'Samus Aran', inqsRange: [2400, 2500] },
          { name: 'The Doctor', inqsRange: [2400, 2500] },
          { name: 'Zaphod Beeblebrox', inqsRange: [2200, 2800] }
        ];
  
        // Create an array of funnel rows using map
        return staffData.map(staff => {
          // Generate the inquiries (inqs) value
          const inqs = this.randomInt(staff.inqsRange[0], staff.inqsRange[1]);
  
          // For applications, we use a random percentage between 5% and 20% of inqs.
          const apps = Math.round(inqs * (this.randomInt(5, 20) / 100));
  
          // For each subsequent step, use a random percentage between 20% and 50%
          const complete = Math.round(apps * (this.randomInt(20, 50) / 100));
          const admit    = Math.round(complete * (this.randomInt(20, 50) / 100));
          const deposit  = Math.round(admit * (this.randomInt(20, 50) / 100));
          const enroll   = Math.round(deposit * (this.randomInt(20, 50) / 100));
  
          // Return an object with the funnel data for this staff member.
          return {
            staffAssigned: staff.name,
            inqs: inqs,
            apps: apps,
            complete: complete,
            admit: admit,
            deposit: deposit,
            enroll: enroll
          };
        });
      },
      // Optional: Method to refresh/regenerate the funnel data when needed.
      refreshFunnelData() {
        this.funnel = this.generateFunnelData();
      }
    }
  };
  </script>
  
  <style scoped>
  /* Optional styling */
  table {
    width: 100%;
    margin-top: 1em;
    border-collapse: collapse;
  }
  th {
    background-color: #302a2a;
  }
  td, th {
    text-align: center;
    padding: 0.5em;
  }
  button {
    margin-top: 1em;
  }
  </style>
  